import { render } from "./404.vue?vue&type=template&id=6363ee27&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=6363ee27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6363ee27"]])

export default __exports__